import { Link, NavLink } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { LogOut, ShieldCheck } from "lucide-react";

export default function Nav() {
  const { user, logout } = useAuth();

  const linkClass = ({ isActive }) =>
    `text-xs tracking-[0.2em] uppercase transition-colors duration-200 hover:text-primary ${
      isActive ? "text-primary" : "text-foreground/70"
    }`;

  return (
    <header
      data-testid="site-nav"
      className="sticky top-0 z-50 w-full backdrop-blur-xl bg-background/75 border-b border-border/60"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
          <span className="font-serif text-xl md:text-2xl font-semibold tracking-[0.15em]">
            MONEYSSANCE
          </span>
        </Link>
        <nav className="hidden md:flex items-center gap-10">
          <NavLink to="/thoughts" className={linkClass} data-testid="nav-thoughts">
            Thoughts
          </NavLink>
          <NavLink to="/blog" className={linkClass} data-testid="nav-blog">
            Journal
          </NavLink>
          <NavLink to="/tools" className={linkClass} data-testid="nav-tools">
            Tools
          </NavLink>
          <NavLink to="/about" className={linkClass} data-testid="nav-about">
            About
          </NavLink>
        </nav>
        <div className="flex items-center gap-3">
          {user?.is_admin && (
            <Link
              to="/admin"
              data-testid="nav-admin"
              className="hidden sm:inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] text-primary border border-primary/40 rounded-full px-3 py-1.5 hover:bg-primary hover:text-primary-foreground transition-colors"
            >
              <ShieldCheck size={14} strokeWidth={1.5} /> Admin
            </Link>
          )}
          {user ? (
            <button
              onClick={logout}
              data-testid="nav-logout"
              className="inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] text-foreground/70 hover:text-primary transition-colors"
            >
              <LogOut size={14} strokeWidth={1.5} /> Sign out
            </button>
          ) : (
            <Link
              to="/login"
              data-testid="nav-login"
              className="inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] rounded-full border border-foreground/20 px-4 py-1.5 hover:border-primary hover:text-primary transition-colors"
            >
              Sign in
            </Link>
          )}
        </div>
      </div>
    </header>
  );
}
